// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1p6MC","content":"Consent_content___uFT6","footer":"Consent_footer__1K0mn"};